const apiUrl = "https://api.tripsecuregh.com/api";
// const apiUrl = "http://84.247.181.60:2000/api";

const Config = {
  apiUrl,
}

export default Config;